<script setup lang="ts">
import { useDeclarationProcess } from '@/helpers/useDeclarationProcess';
import { onBeforeMount } from 'vue';
const { send } = useDeclarationProcess();
onBeforeMount(() => {
  send('READY');
});
</script>

<template>
  <div></div>
</template>
